import { useState } from "react";
import { Button, message } from "antd";
import axios from "axios";
import "../css/loadprint.css";
import { createPdfRePrintAcc1 as printPDF1 } from "../pdf/new/ExportRePrintAcc1";
import { createPdfRePrintAcc2And8 as printPDF28 } from "../pdf/new/ExportRePrintAcc2And8";
import { createPdfRePrintAcc3 as printPDF3 } from "../pdf/new/ExportRePrintAcc3";
import { update_print_cc_manual, HEADERS_BASIC90 } from "../api/apiCent90";

/**
 * PrintPDFLetter
 * พิมพ์จดหมายนอกรอบ (ค้นทีละเลขสัญญา ไม่เกิน ~10 หน้า) -> พิมพ์ครั้งเดียว ไม่ต้องแบ่ง batch แบบ PrintPDF
 * พิมพ์แล้วมาร์ค date_print ผ่าน update-print-cc (flagStatus 2 = สาขาธุรการ)
 *
 * props:
 *  - dataTabelB : ข้อมูลจาก load-cc-h (สัญญาเดียว = contractSchema เดียว)
 *  - roundDate  : รอบวันที่ที่ใช้ค้นหา load-cc-h
 */
function PrintPDFLetter({ dataTabelB, roundDate }) {
  const [printing, setPrinting] = useState(false);

  const safeData = Array.isArray(dataTabelB) ? dataTabelB : [];

  const triggerPrintWindow = (blobUrl) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.top = "-9999px";
    iframe.style.left = "-9999px";
    iframe.style.width = "1000px";
    iframe.style.height = "1000px";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    iframe.onload = () => {
      const win = iframe.contentWindow;
      win.focus();
      win.print();

      // ตั้งเวลาลบ iframe ทิ้ง (เผื่อไว้ 5 นาทีค่อยลบ เพื่อไม่ให้ error ตอนปริ้น)
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
        URL.revokeObjectURL(blobUrl);
      }, 300000);
    };

    iframe.src = blobUrl;
  };

  const createPdf = (data, schemaKey) => {
    if (schemaKey === "lsfhp")
      return printPDF1(data, schemaKey, data.length, 0);
    if (schemaKey === "psfhp" || schemaKey === "rpsl")
      return printPDF3(data, schemaKey, data.length, 0);
    return printPDF28(data, schemaKey, data.length, 0);
  };

  const handlePrint = async () => {
    if (safeData.length === 0) return;
    const schemaKey = safeData[0].contractSchema;

    setPrinting(true);
    try {
      const blobUrl = await createPdf(safeData, schemaKey);
      triggerPrintWindow(blobUrl);

      await axios.post(
        update_print_cc_manual,
        {
          date: roundDate,
          contractSchema: schemaKey,
          user: localStorage.getItem("USERNAME"),
          flagStatus: 2,
        },
        { headers: HEADERS_BASIC90 },
      );
    } catch (error) {
      console.error("Error:", error);
      message.error("พิมพ์ / บันทึกสถานะพิมพ์ไม่สำเร็จ");
    } finally {
      setPrinting(false);
    }
  };

  return (
    <Button
      type="primary"
      onClick={handlePrint}
      loading={printing}
      disabled={safeData.length === 0}
      danger
    >
      พิมพ์ PDF ({safeData.length} ใบ)
    </Button>
  );
}

export default PrintPDFLetter;
